<template>
  <div class="box" v-loading="loading2"
       element-loading-text="拼命加载中"
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="userInfo">
        <img v-bind:src="userIcon">
        <div v-if="!vipStatus" >
          <p>{{freeNumber}}<span>次</span></p>
          <span>剩余免费查询</span>
        </div>
        <div v-if="vipStatus" >
          <p>{{vipDays}}<span>天</span></p>
          <span>vip有效期</span>
        </div>
        <a v-if="!vipStatus" @click="goPay('kt')" >获得更多</a>
        <a v-if="vipStatus" @click="goPay('kt')" >续费VIP</a>
      </div>
      <div class="clickList">
        <div style="border-bottom:1px solid rgba(175, 164, 164, 0.31)">
          <p>邀请好友</p>
          <span>邀请一位多一次机会</span>
        </div>
        <div style="border-bottom:1px solid rgba(175, 164, 164, 0.31)" @click="goList">
          <p>查询历史</p>
          <span style="color: #000;" v-if="cxListNum !== 0" >{{cxListNum}}</span>
        </div>
        <div style="border-bottom:1px solid rgba(175, 164, 164, 0.31)"  @click="goPayHistroyList">
          <p>购买历史</p>
          <span style="color: #000;" v-if="payHistroyList !== 0" >{{payHistroyList}}</span>
        </div>
        <a href="https://www.fbee.one" target="_blank">
          <p>下载Fbee</p>
        </a>
      </div>
    <div class="successTip" v-if="TipStutas">
      {{TipStutasText}}
    </div>
  </div>
</template>

<script>
import Config from '../config/index'
import callApi from '../../static/callApi'
import moment from 'moment'
export default {
  name: 'userInfo',
  data () {
    return {
      vipStatus: false,
      popoverStatus: false,
      TipStutas: false,
      TipStutasText: '',
      freeNumber: '',
      userIcon: '',
      vipDays: '',
      buttonStatus: true,
      cxListNum: 0,
      loading2: false,
      payHistroyList: 10
    }
  },
  created: function () {
    this.cxUserInfo()
  },
  methods: {
    cxUserInfo: function () {
      this.loading2 = true
      let _this = this
      callApi({
        method: 'get',
        url: Config.path + '/fbeeapi/asset/getassetuser',
        headers: {versioncode: 1.0, platform: 'smallprogram'}
      }, (response) => {
        _this.userIcon = String(response.data.content.assetUser.userIcon)
        if (response.data.content.assetUser.membersNumber === 0) {
          _this.freeNumber = response.data.content.assetUser.freeNumber
          if (Number(_this.freeNumber) <= 0) {
            _this.buttonStatus = false
          }
          _this.vipStatus = false
        } else {
          var a = moment(response.data.content.assetUser.membersNumber)
          var b = moment(response.data.content.assetUser.openDate)
          _this.vipDays = Number(a.diff(b, 'day', true)).toFixed(0)
          _this.vipStatus = true
        }
        this.cxListNum = response.data.content.assetUser.useQueryCount
        this.loading2 = false
      }, this)
    },
    goList: function () {
      this.$router.push({path: '/asstsHistroy'})
    },
    goPay: function (zt) {
      this.$router.push({path: '/fbeePay', query: {zt: zt}})
    },
    goPayHistroyList: function () {
      this.$router.push({path: '/fbeePayHistrony'})
    },
    openmessage: function (msg) {
      let _this = this
      this.TipStutasText = msg
      this.TipStutas = true
      setTimeout(function () {
        _this.TipStutasText = ''
        _this.TipStutas = false
      }, 2000)
    },
    goback: function () {
      this.$router.push({path: '/'})
    }
  }
}
</script>

<style scoped>
  .box{
    background-color: #0A274A;
    width: 100%;
    height: inherit;
  }
  .userInfo{
    width: 7.867rem;
    height: 1.933rem;
    position: absolute;
    left: 1.333rem;
    top: 0.5333rem;
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
  }
  .userInfo img{
    width: 1.6rem;
    height: 1.6rem;
    border-radius: 100%;
    border: 0.05rem solid #fff;
  }
  .userInfo div{
    margin-left: 0.533rem;
  }
  .userInfo div p{
    font-family: PingFangSC-Regular;
    font-size: 1.2rem;
    color: #FFFFFF;
    line-height: 1rem;
  }
  .userInfo div p span{
    font-family: PingFangSC-Medium;
    font-size: 0.32rem;
    color: #FFFFFF;
  }
  .userInfo div>span{
    opacity: 0.5;
    font-family: PingFangSC-Medium;
    font-size: 0.32rem;
    color: #FFFFFF;
    line-height: 0.32rem;
  }
  .userInfo a{
    background-image: linear-gradient(-165deg, #FCEF22 0%, #FFDA28 100%);
    border-radius: 1.333rem;
    font-family: PingFangSC-Regular;
    font-size: 0.427rem;
    color: #744A05;
    text-align: center;
    display: block;
    width: 2.933rem;
    height: 1.333rem;
    line-height: 1.333rem;
    position: absolute;
    right: 0;
  }
  .clickList{
    width: 8.667rem;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    background-color: #fff;
    border-radius: 0.26667rem;
    top: 3.3667rem;
  }
  .clickList>div{
    height: 1.6rem;
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
    background-image: url("/static/goico.png");
    background-size:  0.2rem 0.4rem;
    background-repeat: no-repeat;
    background-position: 8rem  50%;
  }
  .clickList>a{
    height: 1.6rem;
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
    background-image: url("/static/goico.png");
    background-size:  0.2rem 0.4rem;
    background-repeat: no-repeat;
    background-position: 8rem  50%;
    text-decoration: none;
  }
  .clickList>div>p{
    font-family: PingFangSC-Regular;
    font-size: 0.427rem;
    color: #584F60;
    margin-left: 0.6667rem;
  }
  .clickList>a>p{
    font-family: PingFangSC-Regular;
    font-size: 0.427rem;
    color: #584F60;
    margin-left: 0.6667rem;
    text-decoration: none;
    display: block;
  }
  .clickList>div>span{
    font-family: PingFangSC-Regular;
    font-size: 0.427rem;
    color: #9B9B9B;
    text-align: right;
    position: absolute;
    right: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/userInfo.vue